import { render, staticRenderFns } from "./AuctionFlashMessages.vue?vue&type=template&id=e5b88b06&"
import script from "./AuctionFlashMessages.vue?vue&type=script&lang=js&"
export * from "./AuctionFlashMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports